import * as Types from '../../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ArchiveTaskRateSheetMutationVariables = Types.Exact<{
  rateSheetName: Types.Scalars['String'];
}>;


export type ArchiveTaskRateSheetMutation = { __typename?: 'MutationModel', taskRates?: { __typename?: 'TaskRatesMutationModel', archiveRateSheet?: { __typename?: 'ValidationResponse', errors?: Array<{ __typename?: 'ValidationError', argumentName?: string | null, message: string } | null> | null } | null } | null };


export const ArchiveTaskRateSheetDocument = gql`
    mutation ArchiveTaskRateSheet($rateSheetName: String!) {
  taskRates {
    archiveRateSheet(rateSheetName: $rateSheetName) {
      errors {
        argumentName
        message
      }
    }
  }
}
    `;
export type ArchiveTaskRateSheetMutationFn = Apollo.MutationFunction<ArchiveTaskRateSheetMutation, ArchiveTaskRateSheetMutationVariables>;

/**
 * __useArchiveTaskRateSheetMutation__
 *
 * To run a mutation, you first call `useArchiveTaskRateSheetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveTaskRateSheetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveTaskRateSheetMutation, { data, loading, error }] = useArchiveTaskRateSheetMutation({
 *   variables: {
 *      rateSheetName: // value for 'rateSheetName'
 *   },
 * });
 */
export function useArchiveTaskRateSheetMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveTaskRateSheetMutation, ArchiveTaskRateSheetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveTaskRateSheetMutation, ArchiveTaskRateSheetMutationVariables>(ArchiveTaskRateSheetDocument, options);
      }
export type ArchiveTaskRateSheetMutationHookResult = ReturnType<typeof useArchiveTaskRateSheetMutation>;
export type ArchiveTaskRateSheetMutationResult = Apollo.MutationResult<ArchiveTaskRateSheetMutation>;
export type ArchiveTaskRateSheetMutationOptions = Apollo.BaseMutationOptions<ArchiveTaskRateSheetMutation, ArchiveTaskRateSheetMutationVariables>;